"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHelmet = require("react-helmet");

var PortfolioMetaInfo = function PortfolioMetaInfo(_ref) {
  var title = _ref.title,
      description = _ref.description,
      keywords = _ref.keywords,
      icon = _ref.icon,
      imageURL = _ref.imageURL,
      themeColor = _ref.themeColor;
  return /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("html", {
    prefix: "og: https://ogp.me/ns#"
  }), /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("meta", {
    name: "description",
    content: description
  }), /*#__PURE__*/_react["default"].createElement("meta", {
    property: "og:description",
    content: description
  }), keywords && /*#__PURE__*/_react["default"].createElement("meta", {
    name: "keywords",
    content: keywords.join(', ')
  })
  /* this is required, but being defensive */
  , icon && /*#__PURE__*/_react["default"].createElement("link", {
    rel: "icon",
    href: icon
  }), icon && /*#__PURE__*/_react["default"].createElement("link", {
    rel: "apple-touch-icon",
    href: icon
  }), imageURL && /*#__PURE__*/_react["default"].createElement("meta", {
    property: "og:image",
    content: imageURL
  }), imageURL && /*#__PURE__*/_react["default"].createElement("meta", {
    property: "twitter:image",
    content: imageURL
  }), imageURL && /*#__PURE__*/_react["default"].createElement("meta", {
    property: "twitter:image:src",
    content: imageURL
  }), window && /*#__PURE__*/_react["default"].createElement("link", {
    rel: "canonical",
    content: window.location.host
  }), window && /*#__PURE__*/_react["default"].createElement("meta", {
    property: "og:url",
    content: window.location.host
  }), /*#__PURE__*/_react["default"].createElement("meta", {
    property: "og:title",
    content: title
  }), themeColor && /*#__PURE__*/_react["default"].createElement("meta", {
    name: "theme-color",
    content: themeColor
  }));
};

PortfolioMetaInfo.defaultProps = {
  description: '',
  keywords: [],
  icon: '',
  imageURL: undefined,
  themeColor: ''
};
PortfolioMetaInfo.propTypes = {
  title: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string,
  keywords: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired),
  icon: _propTypes["default"].string,
  imageURL: _propTypes["default"].string,
  themeColor: _propTypes["default"].string
};
var _default = PortfolioMetaInfo;
exports["default"] = _default;